import Index from '@/views/exhibitor/contact/Index.vue';
import List from '@/views/exhibitor/contact/List.vue';
import Chat from '@/views/exhibitor/contact/Chat.vue';
import { auths, actors } from '@/router/options';

const routes: any[] = [
  {
    path: 'contact',
    redirect: { name: 'exhibitor-contact-list' },
    component: Index,
    children: [
      {
        name: 'exhibitor-contact-list',
        path: '',
        component: List,
        meta: {
          title: 'お問い合わせ一覧',
          actor: actors.exhibitor,
          auth: auths.required,
        },
      },
      {
        name: 'exhibitor-contact-chat',
        path: ':id',
        component: Chat,
        meta: {
          title: 'お問い合わせ詳細',
          actor: actors.exhibitor,
          auth: auths.required,
        },
      },
    ],
  },
];

export default {
  routes,
};
